'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { reportMetaSignupConversion } from '@/lib/analytics/report-meta-signup';

/**
 * 挂在根布局统一监听注册转化（模式同 XSignupTracker）。
 * 主站 /sign-up 注册后强制落到 /projects 等主站页面，Studio 的 tracker 覆盖不到，
 * 因此主站也需要挂载；与 Studio 侧共用去重键，不会重复计数。
 */
export function MetaSignupTracker() {
  const { isLoaded, isSignedIn, user } = useUser();

  const userId = user?.id;
  const createdAtMs = user?.createdAt?.getTime();

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !userId || !createdAtMs) return;

    const ac = new AbortController();
    void reportMetaSignupConversion({ userId, createdAtMs }, ac.signal);

    return () => ac.abort();
  }, [isLoaded, isSignedIn, userId, createdAtMs]);

  return null;
}
